import React, {Component} from 'react';
import Header from './../Layout/Header';
import Footer from './../Layout/Footer2';
import { Helmet } from 'react-helmet';
import ByCountry from './../Element/ByCountry';

class AllJobsByCountry extends Component {
    render() {
        return (
            <div className="page-wraper">
                <Header />

                <Helmet>
                    <title>Remote Jobs by Country | Work From Home Opportunities Worldwide | OpenToWorkRemote</title>
                    <meta name="description" content="Find remote jobs and work from home opportunities worldwide. Search remote positions by country, including USA, UK, Canada, Australia, and more. Access global remote work opportunities. Updated daily. #RemoteWork #WorkFromHome" />
                    <meta name="keywords" content="remote jobs by country, work from home worldwide, remote work opportunities by country, remote positions globally, remote career international, remote employment worldwide, virtual jobs by country" />
                    <meta property="og:title" content="Remote Jobs by Country | OpenToWorkRemote" />
                    <meta property="og:description" content="Find remote jobs and work from home opportunities worldwide. Search remote positions by country." />
                    <link rel="canonical" href="https://www.opentoworkremote.com/all-jobs-by-country" />
                </Helmet>

                <ByCountry />

                <Footer />
            </div>
        );
    }
};

export default AllJobsByCountry;
